
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeatexhanger as ObiHeatexhangerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heatexhanger.js';
 
 
 

 
 export const ObiHeatexhanger = createComponent({
   react: React,
   tagName: 'obi-heatexhanger',
   elementClass: ObiHeatexhangerElement,
   events: {
     
   }
  });
 
 